import { from, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { TagsSchema } from '../../_offline/models/tags.schema';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class TagsDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<TagsSchema> {
    return this.ipcSendSync(IPC_CHANNEL.TAGS.GET_ALL, this.tenantId);
  }

  putAll(tagsSchema: TagsSchema): Observable<TagsSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.TAGS.PUT_ALL, tagsSchema);
  }

  patch(updatedTag: TagsSchema): Observable<TagsSchema | null> {
    return from( this.electronService.invoke(IPC_CHANNEL.TAGS.PATCH_ONE, this.tenantId, updatedTag));
  }

}
